import { render, staticRenderFns } from "./DetailOrderView.vue?vue&type=template&id=6b2276a0&scoped=true"
import script from "./DetailOrderView.vue?vue&type=script&lang=js"
export * from "./DetailOrderView.vue?vue&type=script&lang=js"
import style0 from "./DetailOrderView.vue?vue&type=style&index=0&id=6b2276a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2276a0",
  null
  
)

export default component.exports